module.exports = "query ($id: ID!) {\n  User(id: $id) {\n    id\n    name\n    avatar\n  }\n}\n"